import { Chart } from 'chart.js/auto';
import 'chartjs-adapter-date-fns';
import { format } from 'date-fns';
import randomColor from 'randomcolor';
import layoffData from '../../data/indonesian-tech-layoff.json';
import { initChart } from '../bubbleChart';
import { calculateR, CompanyDatasetsMap, filterDatasetsMap } from '../dataset';
import { createExternalTooltipHandler } from '../tooltip';

Chart.defaults.elements.point.hitRadius = 15;

const datasetsMap = generateDatasetsMap(layoffData as LayoffEvent[]);
initChart<LayoffEvent>({
  datasetsMap,
  externalTooltipHandler: createExternalTooltipHandler<LayoffEvent>((d) => {
    const row = d.data;
    const infoData = [
      row.company_name,
      `&#128100; ~${row.total_impacted} impacted`,
      format(new Date(row.date), 'MMMM d, yyyy'),
      `<a style="color: #1d63dc; text-decoration: none;" href="${row.link}" target="_blank"><span style="text-decoration: underline;">News Source</span></a>`,
    ];
    return infoData.join('<br />');
  }),
  onSearch: (keyword) => {
    return filterDatasetsMap<LayoffEvent>(keyword, datasetsMap, (r) => {
      return `${r.date}`.toLowerCase().includes(keyword.toLowerCase());
    });
  },
});

export interface LayoffEvent {
  date: string;
  company_name: string;
  total_impacted: number | 'unknown';
  link: string;
}

export function generateDatasetsMap(layoffData: LayoffEvent[]) {
  const datasetsMap: CompanyDatasetsMap<LayoffEvent> = {};
  for (const row of layoffData) {
    if (datasetsMap[row.company_name] === undefined) {
      datasetsMap[row.company_name] = {
        label: row.company_name,
        data: [],
        backgroundColor: randomColor({
          luminosity: 'dark',
          alpha: 0.7,
          format: 'rgba',
          seed: row.company_name,
        }),
      };
    }
    datasetsMap[row.company_name].data.push({
      data: row,
      y: new Date(row.date).getTime(),
      x: row.total_impacted === 'unknown' ? 0 : row.total_impacted,
      r: 1,
    });
  }
  return datasetsMap;
}
